import React from 'react'
import styled from 'styled-components'
import colors from '@constants/colors'

export default ({ onClick, expanded, expandedText, closedText, alignSelf }) => {
    return (
        <Button alignSelf={alignSelf} onClick={onClick}>
            {expanded ? expandedText : closedText}
        </Button>
    )
}

const Button = styled.button`
  font-size: 12px;
  padding: 0px 8px;
  line-height: 20px;
  border-radius: 4px;
  white-space: nowrap;
  ${(p) => p.alignSelf && 'align-self:' + p.alignSelf + ';'}
  color: ${colors.APP_WHITE};
  background-color: ${colors.BUTTON_DARK};
`
